import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LOR from './pages/LOR'
import GigGuild from './pages/GigGuild'
import StayFinder from './pages/StayFinder';
import Habit from './pages/Habit_track';
import JChat from './pages/JChat'
import NutriScale from './pages/NutriScale';
import Justicebot from './pages/Justicebot';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },

  {
    path: "gig",
    element: <GigGuild/>,
  },

  {
    path: "stayfinder",
    element: <StayFinder/>,
  },


  {
    path: "nutriscale",
    element: <NutriScale/>,
  },


  {
    path: "justice",
    element: <Justicebot/>,
  },


  {
    path: "habit_track",
    element: <Habit/>,
  },

  {
    path: "lor",
    element: <LOR/>,
  },

  {
    path: "jchat",
    element: <JChat/>,
  },

  
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router}/>
);


